/**
 *
 */
import {
  //isPdfOnlineDomain,
  //isFZK8SDomain,
  //isDevDomain,
  getBaseUrl,
  //getQueryVariable
} from "Utils/utils";

import {
    isMobile as IS_MOBILE,
} from "Utils/device";

// Url route path
export const ROUTE_PATH_ROOT = '/';

export const ROUTE_PATH_SUBSCRIBE = '/subscribe';
export const ROUTE_PATH_PRIVACY_POLICY = '/privacy-policy';
///
export const ROUTE_PATH_TERMS_OF_USE = '/term-of-use';
export const ROUTE_PATH_TERMS_OF_SERVICE = '/terms-of-service';
export const ROUTE_PATH_404 = '/404';
export const ROUTE_PATH_TEST_CASE = '/test-case';
export const ROUTE_PATH_DEPLOY = '/deploying';
export const ROUTE_PATH_LOGIN_SUCCESS = '/login/success';
export const ROUTE_PATH_LOGOUT_SUCCESS = '/logout/success';
export const ROUTE_PATH_PASSWORD_EXPIRED = '/site/password-expired';
export const ROUTE_PATH_PASSWORD_CHANGE_SUCCESS = '/site/password-change-success';
export const ROUTE_PATH_FEEDBACK = '/feedback'
export const ROUTE_PATH_SHARE = '/download-share'
export const ROUTE_PATH_LOADING = '/loading'
export const ESIGNCN_TOOL_PAGE = '/internal_identity_verify';
export const ESIGNCN_EVIDENCE_TOOL_PAGE = '/external_extract_tool';
export const ESIGNCN_AUDIT_TRAIL = '/eSignCN_signing_report';
export const ESIGNCN_WEB_CONTAINER = '/esigncn-web-container';
export const OPEN_FILE_LOCAL = '/open-pdf';

// Here, url will be not reset to '/'
const ROUTE_PATH_MATCH_PAGE_LIST = [
  ROUTE_PATH_ROOT,
  ROUTE_PATH_404,
  ROUTE_PATH_TEST_CASE,
  ROUTE_PATH_DEPLOY,
  ROUTE_PATH_SUBSCRIBE,
  ROUTE_PATH_PRIVACY_POLICY,
  ROUTE_PATH_TERMS_OF_USE,
  ROUTE_PATH_TERMS_OF_SERVICE,
  ROUTE_PATH_FEEDBACK,
  ROUTE_PATH_SHARE,
  ROUTE_PATH_LOADING,
  ESIGNCN_TOOL_PAGE,
  ESIGNCN_EVIDENCE_TOOL_PAGE,
  ESIGNCN_AUDIT_TRAIL,
  ESIGNCN_WEB_CONTAINER,
  OPEN_FILE_LOCAL
]

const ROUTE_PATH_AUTO_SIGN_IN = [
  
]
const ROUTE_PATH_AVOID_AUTO_SIGN_IN = [
  
]
// check with remember-me
export function isNeedAutoSignIn(path){
  return  ROUTE_PATH_AUTO_SIGN_IN.indexOf(path) !== -1 ? true:false;
}

export function isAvoidAutoSignIn(path) {
  return  ROUTE_PATH_AVOID_AUTO_SIGN_IN.indexOf(path) !== -1 ? true:false;
}

export function isPathMatchValidPage(path) {
  return  ROUTE_PATH_MATCH_PAGE_LIST.indexOf(path) !== -1 ? true:false;
}
export function isMobile() {
  return IS_MOBILE;
}
export function isSharedClound (){
  return window.location.pathname.indexOf(ROUTE_PATH_SHARE) !== -1?true:false;
}

const SDK_VERSION = '_t_='+ window.__hashVersion__;
//export const DOMAIN_PDFONLINE_US_CDN = 'https://1337174406.rsc.cdn77.org'
let WEBSDK_URL =  '.';
// if(isPdfOnlineDomain()||isFZK8SDomain()|| isDevDomain()){
//   let debugValue = getQueryVariable('cdn');
//   if( debugValue !== null)
//     WEBSDK_URL =  DOMAIN_PDFONLINE_US_CDN

// }

// only one file for addons
let addonsPC = WEBSDK_URL + '/foxitwebsdk/lib/uix-addons/allInOne.js' + '?' + SDK_VERSION;
let addonsStylePC = WEBSDK_URL + '/foxitwebsdk/lib/uix-addons/allInOne.css' + '?' + SDK_VERSION;
let addonsMobile = WEBSDK_URL + '/foxitwebsdk/lib/uix-addons/allInOne.mobile.js' + '?' + SDK_VERSION;
let addonsMobileStylePC = WEBSDK_URL + '/foxitwebsdk/lib/uix-addons/allInOne.mobile.css' + '?' + SDK_VERSION;
let addons = isMobile()? addonsMobile:addonsPC;
// let addons = isMobile()? addonsPC:addonsPC;

let baseUrl = getBaseUrl();

export let FOXITWEBSDK_URLS = {
  // UIExtension: WEBSDK_URL + '/foxitwebsdk/lib/UIExtension.full.js' + '?' + SDK_VERSION,
  UIExtension: WEBSDK_URL + '/foxitwebsdk/lib/UIExtension.full.js',
  workerPath:  '.' + '/foxitwebsdk/lib/',//WEBSDK_URL + '/foxitwebsdk/lib/',
  libPath:  WEBSDK_URL + '/foxitwebsdk/lib',
  fontPath: WEBSDK_URL === '.' ? baseUrl+'foxitwebsdk/external/brotli': WEBSDK_URL+'/foxitwebsdk/external/brotli',
  addonPath:WEBSDK_URL + '/foxitwebsdk/lib/uix-addons/',
  addons: addons,
  addonsStylePC,
  addonsMobileStylePC
}


export const COMMIT_ID = 'CommitID';
export const PHANTOMONLINE_GLOBAL_CONFIG = 'phantomOnlineGlobalConfig';

export const USER_CURRENT_TOKEN = 'currentToken';

export const URL_CWS_API = 'cwsApiUrl';
export const URL_CLOUD_API = 'cloudApiUrl';

export const URL_APPSTORE_API = 'appStoreApiUrl'

export const  URL_PLATFORM = 'platformApiUrl';
export const  URL_ESIGNCN = 'eSignCNUrl';

export const  URL_FOXIT_SIGN = 'foxitSignUrl';
export const URL_IDOX_API = 'idoxAiUrl';
export const URL_ACCOUNT = 'accountApiUrl'
export const URL_CMIS = 'cmisUrl';
export const IS_NEED_AB_ROLE = 1; // 1: 需要进行ABtest的用户分组, 0: 不需要
export const USER_AB_ROLE = { A: 0, B: 1 }; // 0:角色A, 1:角色B

export const TASK_STATUS = {
  WAITING: 'task-step-waiting',
  ON_UPLOADING: 'task-step-on-loading',
  BEGIN_UPLOAD: 'task-step-begin-upload',
  UPLOADED: 'task-step-uploaded',
  CONVERT: 'task-step-begin-convert',
  MINOTOR: 'task-step-in-convert',
  FINISH: 'task-step-finish',
  ERROR: 'task-step-error',
  CANCEL: 'task-step-cancel',
  COMBINE:'task-step-begin-combine',
  DOWNLOAD_FILE: 'task-step-begin-download-file',
  DOWNLOAD_FILE_SUCCESS: 'task-step-complete-download-file',
  BEGIN_BY_GSDK:'task-step-begin-by-gsdk',
  DOING_BY_GSDK:'task-step-doing-by-gsdk',
  FINISH_BY_GSDK:'task-step-finish-by-gsdk',
  ERROR_BY_GSDK:'task-step-error-by-gsdk',
  BEGIN_BY_GSDK_EXPORT_IMAGES: 'task-step-begin-by-gsdk-export-images',
  DOING_BY_GSDK_EXPORT_IMAGES:'task-step-doing-by-gsdk-export-images',
  FINISH_BY_GSDK_EXPORT_IMAGES:'task-step-finish-by-gsdk-export-images',
  ERROR_BY_GSDK_EXPORT_IMAGES:'task-step-error-by-gsdk-export-images',
  COMBINEDOWNLOAD:'task-step-begin-combine-download',
}


export const CONVERT_TYPE = {
  UNKNOWN : -1,
  PDFTOCPDF : 0,
  IMGTOPDF : 1,
  OPTIMIZER : 2,
  WATERMARK : 3,
  MERGEPDF : 4,
  PDFTOTXT : 5,
  PDFTOIMG : 6,
  //PDFPROTECT : 7,
  PDFREDACTOR : 8,
  PDFHEADERFOOTER : 9,
  ROTATEPDF : 10,
  PDFTOWORD : 11,
  SPLITPDF : 12,
  PAGEORGANIZER : 13,
  PDFTOXMLSPREADSHEET2003:32,
  PDFTOEXCEL : 14,
  PDFTOHTML : 15,
  WORDTOPDF : 16,
  PDFFLATTEN : 17,
  EXCELTOPDF : 18,
  PPTTOPDF : 19,
  TXT2PDF : 20,
  HTML2PDF : 21,
  PDFTOPPT : 22,
  PDFTORTF : 25,
  PDFTOWORD2003 : 26,
  PDFTOHTML_SOLID : 30,
  PDFVERSION : 31,
  OCR : 35,
  COMMENT_COMBINE:4,
  PREFLIGHT_PROFILES: 38,
}

export const DEFAULT_FILE_NAME  ={
  4:"Binder.pdf"
}

const TOPDF_LIST = [
  CONVERT_TYPE.PDFHEADERFOOTER,
  CONVERT_TYPE.WATERMARK,
  CONVERT_TYPE.MERGEPDF,
  CONVERT_TYPE.OPTIMIZER,
  CONVERT_TYPE.IMGTOPDF,
  CONVERT_TYPE.PPTTOPDF,
  CONVERT_TYPE.WORDTOPDF,
  CONVERT_TYPE.EXCELTOPDF,
  CONVERT_TYPE.TXT2PDF,
  CONVERT_TYPE.HTML2PDF
];
/**            return CONVERT_TYPE.IMGTOPDF;
          case 'ppt':
          case 'pptx':
            return CONVERT_TYPE.PPTTOPDF;
          case 'doc':
          case 'docx':
            return CONVERT_TYPE.WORDTOPDF;
          case 'xls':
          case 'xlsx':
            return CONVERT_TYPE.EXCELTOPDF;
           case 'txt':
             return CONVERT_TYPE.TXT2PDF; */
const FILE_TOPDF_LIST = [
  CONVERT_TYPE.IMGTOPDF,
  CONVERT_TYPE.PPTTOPDF,
  CONVERT_TYPE.WORDTOPDF,
  CONVERT_TYPE.EXCELTOPDF,
  CONVERT_TYPE.TXT2PDF
]
export function isToPDF(type) {
  return TOPDF_LIST.indexOf(type) !== -1 ? true : false;
}
export function isFileToPDF(type) {
  return FILE_TOPDF_LIST.indexOf(type) !== -1 ? true : false;
}
/**
 * @readonly
 * @enum {string}
 */
export const DATA_TYPE = {
  File:"File",
  FileBuffer:"FileBuffer",
  CMISFileId:"CMISFileId",
  Url:"Url",
  CloudFileId:"CloudFileId",
  Cloud: 'Cloud',
  StorageFile: 'Windows.Storage.StorageFile', //Windows.Storage.StorageFile
}

export const CONVERT_TIME_LIMIT = 10;

export const NOTIFICATION_PARAMS = {
  an: 'Foxit PhantomPDF Online',
  av: '1.0.0.0',
  cv: '2.0.0.0',
}
